export const getBaseSize = (p?: string) => {
    let size: number;
    switch (p) {
        case 'large':
            size = 36;
            break;
        case 'medium':
            size = 32;
            break;
        case 'small':
            size = 28;
            break;
        case 'tiny':
            size = 24;
            break;
        default:
            size = 36;
    }
    return size;
};
